var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShareLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "nuopbq79va",
    width: "183.5%",
    height: "174%",
    x: "-41.7%",
    y: "-32.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rz35p6zlcb",
    d: "M19.464 2.813c2.041 0 3.696 1.655 3.696 3.697 0 2.04-1.655 3.693-3.696 3.693-1.007 0-1.921-.403-2.588-1.057l-5.662 3.347c.113.355.174.733.174 1.125 0 .393-.06.77-.174 1.126l5.662 3.347c.667-.655 1.58-1.058 2.588-1.058 2.04 0 3.696 1.655 3.696 3.695 0 2.042-1.655 3.696-3.696 3.696-2.041 0-3.696-1.654-3.696-3.696 0-.392.061-.77.175-1.125l-5.662-3.346c-.667.655-1.58 1.059-2.589 1.059-2.04 0-3.695-1.657-3.695-3.698 0-2.04 1.655-3.696 3.695-3.696 1.008 0 1.922.404 2.589 1.058l5.662-3.346c-.114-.354-.175-.732-.175-1.124 0-2.043 1.655-3.697 3.696-3.697zm0 15.996c-1.06 0-1.92.86-1.92 1.92s.86 1.92 1.92 1.92 1.92-.86 1.92-1.92-.86-1.92-1.92-1.92zM7.692 11.7c-1.059 0-1.919.86-1.919 1.92s.86 1.92 1.92 1.92c1.059 0 1.92-.86 1.92-1.92s-.861-1.92-1.92-1.92zm11.772-7.11c-1.06 0-1.92.86-1.92 1.92 0 1.059.86 1.918 1.92 1.918s1.92-.86 1.92-1.917c0-1.062-.86-1.921-1.92-1.921z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-302 -632) translate(302 569) translate(0 63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#nuopbq79va)",
    xlinkHref: "#rz35p6zlcb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FAFAFA",
    xlinkHref: "#rz35p6zlcb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28.421V28.421H0z",
    transform: "translate(8 8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareLive);
export default __webpack_public_path__ + "static/media/ic_share_live.9ca0f76c43dc1e2fa1c032010b26435c.svg";
export { ForwardRef as ReactComponent };